import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { BASE_URL } from "../env";
import axios from "axios";
import Navbar from "../../src/components/Navbar";

const QuizUpdate = () => {
	const [values, setValues] = useState({
		quizTime: "",
		quizId: "",
		buttonText: "Update",
	});
	useEffect(() => {
		axios({
			method: "GET",
			url: BASE_URL + "/quiz",
			headers: { "content-type": "application/json" },
		})
			.then((response) => {
				console.log("QuizUpdated", response);
				const { quizId, quizTime } = response.data[0];
				setValues({ ...values, quizTime, quizId });
			})
			.catch((error) => {
				console.log("QUIZ UPDATE ERROR");
			});
	}, []);

	const { _id } = useParams();

	const { quizTime, quizId, buttonText } = values;

	const handleChange = (name) => (event) => {
		// console.log(event.target.value);
		setValues({ ...values, [name]: event.target.value });
	};

	const clickSubmit = (event) => {
		event.preventDefault();
		setValues({ ...values, buttonText: "Updating" });
		axios({
			method: "PUT",
			url: `${BASE_URL}/updateQuiz/${_id}`,
			headers: { "content-type": "application/json" },

			data: { quizTime, quizId },
		})
			.then((response) => {
				console.log("QUIZ UPDATE SUCCESS", response);

				setValues({ ...values, buttonText: "Updated" });
			})
			.catch((error) => {
				console.log("QUIZ UPDATE ERROR");
				setValues({ ...values, buttonText: "Update" });
			});
	};

	return (
		<div>
			<Navbar />

			<h1 className="text-center my-5">Update Quiz Time And Id</h1>

			<div className="container">
				<table class="table">
					<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Quiz Time</th>
							<th scope="col">Quiz Id</th>
							<th scope="col">Update</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th scope="row">1</th>
							<td>
								<input
									type="text"
									onChange={handleChange("quizTime")}
									value={values.quizTime}
								/>
								{/* {quizTime} */}
							</td>
							<td>
								<input
									type="text"
									onChange={handleChange("quizId")}
									value={values.quizId}
								/>
							</td>
							<td>
								<button
									onClick={clickSubmit}
									className="btn btn-warning"
								>
									{buttonText}{" "}
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default QuizUpdate;
